import {GET_INTERVENANT} from "../actions/intervenant.actions";

const initialState = {};

export default function intervenantReducer( state = initialState, action) {

    switch (action.type) {
        case GET_INTERVENANT:
            return action.payload;

        default:
            return state;
    }
}